<template>
	<div style="padding: 10px 10px 10px 0;">
		<el-dialog :title="title" :visible.sync="show" width="670px">
			<el-form ref="form" :model="form" label-width="100px" :inline="true">
				<el-form-item :rules="[{ required: true, message: '所属楼层不能为空' }]" label="所属楼层">
					<el-select :disabled="title[0] == '查'" v-model="form.storey" placeholder="所属楼层">
						<el-option v-for="item in floorList" :label="item.label" :value="item.label"></el-option>
					</el-select>
				</el-form-item>
				<!--el-form-item label="联系人">
					<el-input :disabled="title[0]=='查'" v-model="form.linkName"></el-input>
				</el-form-item-->

				<!-- <el-form-item label="身份证号">
					<el-input :disabled="title[0] == '查'" v-model="form.linkCard"></el-input>
				</el-form-item> -->
				<el-form-item label="商铺类型">
					<el-select :disabled="title[0] == '查'" v-model="form.type">
						<el-option label="普通" :value="0"></el-option>
						<el-option label="特殊" :value="1"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="商铺状态">
					<el-select :disabled="title[0] == '查'" v-model="form.status">
						<el-option label="正常" value="正常"></el-option>
						<el-option label="停用" value="停用"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="水仪表编码">
					<el-input :disabled="title[0] == '查'" v-model="form.waterCode"></el-input>
				</el-form-item>
				<el-form-item label="电仪表编码">
					<el-input :disabled="title[0] == '查'" v-model="form.electricityCode"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button @click="addUser" style="margin-left:30px;" type="primary" size="mini">添加联系人</el-button>
					<el-button v-if="userList.length > 1" @click="delUser" style="margin-left:10px;" type="primary"
						size="mini">减少联系人</el-button>
				</el-form-item>
				<div v-for="(item, index) in userList" :key="index">
					<el-form-item :label="'联系人' + (index + 1)">
						<el-input :disabled="title[0] == '查'" v-model="item.linkName"></el-input>
					</el-form-item>
					<el-form-item label="联系电话">
						<el-input :disabled="title[0] == '查'" v-model="item.linkPhone"></el-input>
					</el-form-item>
				</div>

			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="show = false">取 消</el-button>
				<el-button v-if="title[0] != '查'" type="primary" @click="ok">确 定</el-button>
			</span>
		</el-dialog>
		<el-form :inline="true" :model="selectForm" class="demo-form-inline">
			<div class="flex sb">
				<div>
					<el-form-item label="所属楼层">
						<el-select size="small" v-model="selectForm.storey" placeholder="所属楼层" clearable>
							<el-option v-for="item in floorList" :label="item.label" :value="item.label"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="商铺号">
						<!-- <el-input  size="small" v-model="selectForm.shopNum" placeholder="商铺号" clearable></el-input> -->
						<el-select filterable size="small" v-model="selectForm.shopNum" placeholder="请选择商铺号" clearable
							style="width: 130px;">
							<el-option v-for="item in shopList" :label="item.shopNum" :value="item.shopNum"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="商铺名称">
						<!-- <el-input size="small" v-model="selectForm.shopName" placeholder="商铺名称" clearable></el-input> -->
						<el-select filterable size="small" v-model="selectForm.shopName" placeholder="请选择商铺名称" clearable
							style="width: 240px;">
							<el-option v-for="item in shopList" :label="item.shopName" :value="item.shopName"></el-option>
						</el-select>
					</el-form-item>
					<!-- <el-form-item label="商铺状态">
						<el-select size="small" v-model="selectForm.status">
							<el-option label="正常" value="正常"></el-option>
							<el-option label="停用" value="停用"></el-option>
						</el-select>
					</el-form-item> -->
					<el-form-item label="联系人">
						<el-input  size="small" v-model="selectForm.linkName" placeholder="联系人" clearable></el-input>
					</el-form-item>
					<!-- <el-form-item label="联系方式">
						<el-input  size="small" v-model="selectForm.linkPhone" placeholder="联系方式" clearable></el-input>
					</el-form-item> -->
					<el-form-item>
						<el-button  size="small" type="primary" @click="getAll()">查询</el-button>
					</el-form-item>
					<el-form-item>
						<el-button  size="small" type="primary" @click="dc">导出</el-button>
					</el-form-item>
					<!-- <el-form-item>
						<el-button type="primary" @click="addTemplate">下载导入水电仪表编码模板</el-button>
					</el-form-item>
					<el-form-item>
						<el-upload action="/api/admin/shop/code/importShopCode" name="file" :show-file-list="false"
							:headers="headers" :on-success="success">
							<el-button type="primary">导入水电仪表编码</el-button>
						</el-upload>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="tb">同步水电仪表编码</el-button>
					</el-form-item> -->
					<!-- <el-form-item>
						<el-button type="primary" @click="handleCreate">新增商铺</el-button>
					</el-form-item> -->
					<!-- <el-form-item>
						<el-button type="primary" @click="revenueTemplate">下载营收模版</el-button>
					</el-form-item> -->
					<!-- <el-form-item>
						<el-upload accept=".xlsx,.xls" action="/api/safe/passengerFlow/importEarning" name="file" :show-file-list="false" :headers="headers" :on-success="success">
							<el-button type="primary">导入营收</el-button>
						</el-upload>
					</el-form-item> -->

				</div>

			</div>
		</el-form>
		<el-table :data="data" style="width: 100%" border>
			<el-table-column prop="storey" label="楼层"></el-table-column>
			<el-table-column prop="shopNum" label="商铺编号"></el-table-column>
			<el-table-column prop="shopName" label="商铺名称"></el-table-column>
			<el-table-column prop="brandName" label="经营品牌"></el-table-column>
			<el-table-column prop="area" label="出租面积"></el-table-column>
			<el-table-column prop="shopFormat" label="经营业态"></el-table-column>
			<el-table-column prop="linkName" label="联系人"></el-table-column>
			<el-table-column prop="linkPhone" label="联系电话"></el-table-column>
			<el-table-column prop="linkCard" label="身份证号"></el-table-column>
			<el-table-column prop="status" label="商铺状态"></el-table-column>
			<el-table-column prop="date" label="操作" width="100" align="center">
				<template slot-scope="{row}">
					<!-- <el-button type="text" @click="setRow(row, '1')">详情</el-button>
					<el-button type="text" @click="setRow(row, '2')">编辑</el-button>
					<el-button type="text" @click="setRow3(row)">常用账户</el-button> -->
					<el-button type="text" @click="setRow4(row)">租金调整</el-button>
				</template>
			</el-table-column>
		</el-table>
		<el-pagination :page-sizes="[10, 20, 30, 50]" :page-size="selectForm.pageSize"
			layout="total, sizes, prev, pager, next, jumper" :total="count" @size-change="handleSizeChange"
			@current-change="handleCurrentChange">
		</el-pagination>
		<el-dialog title="以下数据存在问题" :visible.sync="isFail">
			<div style="margin-bottom: 30px;">
				<!-- <h3>已经存在的记录</h3> -->
				<el-table :data="czList" style="width: 100%" border>
					<el-table-column prop="code" label="仪表编号"></el-table-column>
					<el-table-column prop="codeType" label="仪表型号"></el-table-column>
					<el-table-column prop="address" label="仪表地址"></el-table-column>
					<el-table-column prop="areas" label="仪表计量区域"></el-table-column>
					<el-table-column prop="status" label="仪表状态"></el-table-column>
					<el-table-column prop="shopNum" label="商铺号"></el-table-column>
					<el-table-column prop="type" label="类型">
						<template slot-scope="{row}">
							<div>{{ row.type == 1 ? '水' : '电' }}</div>
						</template>
					</el-table-column>

				</el-table>
			</div>
		</el-dialog>



		<el-dialog title="常用账户" :visible.sync="show3" width="780px">

			<el-dialog width="500px" title="新增常用账户" :visible.sync="innerVisible" append-to-body>

				<div style="display: flex;align-items: center;">
					<div style="width:100px;">付款人账号</div><el-input v-model="cardNum" placeholder="请输入付款账号"></el-input>
				</div>
				<div style="display: flex;margin-top:20px;align-items: center;">
					<div style="width:100px;">付款人名称</div><el-input v-model="cardName" placeholder="请输入付款账号"></el-input>
				</div>
				<span slot="footer" class="dialog-footer">
					<el-button @click="innerVisible = false">关 闭</el-button>
					<el-button @click="addData2" type="primary">保 存</el-button>
				</span>
			</el-dialog>
			<div style="display:flex;align-items: center;justify-content: space-between;">
				<div>
					<div>商品编号：{{ obj.shopNum }}</div>
					<div>商品名称：{{ obj.shopName }}</div>
				</div>
				<el-button type="primary" size="small" @click="addRow3">新增账户</el-button>
			</div>

			<el-table :data="data2" style="width: 100%">
				<el-table-column prop="shopNum" label="商铺编号" align="center"></el-table-column>
				<el-table-column prop="accountId" label="付款人账号" align="center"></el-table-column>
				<el-table-column prop="accountName" label="付款人名称" align="center"></el-table-column>
				<el-table-column prop="date" label="操作" align="center">
					<template slot-scope="{row}">
						<el-button type="text" @click="delRow(row)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
		</el-dialog>



		<el-dialog title="租金调整" :visible.sync="show4" width="800px" @close="resetForm('ruleForm')">
			<el-tabs v-model="activeName4" @tab-click="handleClick4">
				<el-tab-pane label="调整" name="first">
					<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
						<el-form-item label="减免商铺" prop="brandName">
							<el-input disabled v-model="ruleForm.brandName"></el-input>
						</el-form-item>
						<el-form-item label="减租类型" prop="type">
							<el-input v-model="ruleForm.type"></el-input>
						</el-form-item>
						<el-form-item label="减租时间" required>
							<el-date-picker v-model="dateArr" type="daterange" range-separator="至" start-placeholder="开始日期"
								end-placeholder="结束日期" value-format="yyyy-MM-dd" @change="changeDateArr">
							</el-date-picker>
						</el-form-item>
						<el-form-item label="减租天数" prop="diffDay">
							<el-input disabled v-model="ruleForm.diffDay"></el-input>
						</el-form-item>
						<el-form-item label="减租金额" prop="rentConcessionMoney">
							<el-input v-model="ruleForm.rentConcessionMoney"></el-input>
						</el-form-item>
						<el-form-item label="减租明细" prop="detail">
							<el-input v-model="ruleForm.detail"></el-input>
						</el-form-item>
						<el-form-item label="备注" prop="remark">
							<el-input v-model="ruleForm.remark"></el-input>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" @click="submitForm('ruleForm')">保存</el-button>
							<!-- <el-button @click="resetForm('ruleForm')">重置</el-button> -->
						</el-form-item>
					</el-form>
				</el-tab-pane>
				<el-tab-pane label="记录" name="second">
					<el-table :data="data4" style="width: 100%">
						<el-table-column prop="shopNum" label="商铺编号" align="center"></el-table-column>
						<el-table-column prop="shopName" label="商铺名称" align="center"></el-table-column>
						<el-table-column prop="type" label="减租类型" align="center"></el-table-column>
						<el-table-column prop="accountName" label="减租时间" align="center">
							<template slot-scope="{row}">
								<span>{{ row.startTime + "-" + row.endTime }}</span>
							</template>
						</el-table-column>
						<!-- <el-table-column prop="accountName" label="减租shi" align="center"></el-table-column> -->
						<el-table-column prop="rentConcessionMoney" label="减租金额" align="center"></el-table-column>
						<el-table-column prop="detail" label="减租明细" align="center"></el-table-column>
						<el-table-column prop="remark" label="备注" align="center"></el-table-column>
					</el-table>
				</el-tab-pane>
			</el-tabs>

		</el-dialog>
	</div>
</template>

<script>
import publicExport from '../../assets/js/publicExport.js';
export default {
	data() {
		return {
			shopList:[],
			data4: [],
			oldRuleForm: {},
			ruleForm: {
				shopId: "",
				brandName: '',
				diffDay: 0,
				rentConcessionMoney: '',
				type: "",
				startTime: "",
				endTime: "",
				detail: "",
				remark: "",
				fileUrl: ""
			},
			rules: {
				brandName: [
					{ required: true, message: '请输入', trigger: 'blur' },
				],
				type: [
					{ required: true, message: '请输入', trigger: 'blur' },
				],
				rentConcessionMoney: [
					{ required: true, message: '请输入', trigger: 'blur' },
				],
				startTime: [
					{ required: true, message: '请输入', trigger: 'blur' },
				],
				endTime: [
					{ required: true, message: '请输入', trigger: 'blur' },
				],
				detail: [
					{ required: true, message: '请输入', trigger: 'blur' },
				],
				rentConcessionMoney: [
					{ required: true, message: '请输入', trigger: 'blur' }
				],
				diffDay: [
					{ required: true, message: '请输入', trigger: 'blur' }
				],

			},
			show4: false,
			activeName4: "first",
			userList: [{
				linkName: "",
				linkPhone: ""
			}],
			// salesVolumeData: [{
			// 	    start: "10000",
			// 		  end: "20000",
			// 		 rent: "0.2"
			// },
			// {
			// 	    start: "20000",
			// 		  end: "50000",
			// 		 rent: "0.08"
			// }],
			// historyData: [{
			// 	    date: "一月",
			// 	turnover: "10000",
			// 	    rent: "2000",
			// 	userName: "赵四",
			//   createTime: "2022-10-31"
			// }],
			// formRent: {
			// 	date: "",
			// turnover: ""
			// },
			data2: [],
			floorList: [
				{
					label: "-1楼"
				},
				{
					label: "1楼"
				},
				{
					label: "2楼"
				},
				{
					label: "3楼"
				},
				{
					label: "4楼"
				},
			],
			title: "新增",
			count: 0,
			headers: {
				Authorization: localStorage.access_token
			},
			show: false,
			show3: false,
			innerVisible: false,
			selectForm: {
				status: "正常",
				currentPage: 1,
				pageSize: 10,
				shopNum: null, //商铺号
				storey: null, //楼层
				shopName: null,
				linkName: null,
				linkPhone: null
			},
			oldForm: "",
			form: {
				storey: "", //楼层
				linkName: '',
				linkPhone: '',
				linkCard: '',
				status: '',
				waterCode: '',
				electricityCode: ''
			},
			data: [],
			isFail: false,
			czList: [],
			cardNum: "",
			cardName: "",
			obj: {},
			dateArr: [],
		}
	},
	methods: {
		getShopList() {
			let selectForm = {
				currentPage: 1,
				pageSize: 1000,
			};
			this.$http.post("/api/bdShop/queryShop", selectForm).then(res => {
				this.shopList = res.data.data.items
			})
		},
		changeDateArr() {
			this.ruleForm.diffDay = 0
			if (this.dateArr.length == 2) {
				this.ruleForm.startTime = this.dateArr[0]
				this.ruleForm.endTime = this.dateArr[1]
				this.getDiffDay(this.dateArr[0], this.dateArr[1])
			} else {
				this.ruleForm.diffDay = 0
				this.ruleForm.startTime = ""
				this.ruleForm.endTime = ""
				this.ruleForm.rentConcessionMoney = 0
			}
		},
		getDiffDay(date_1, date_2) {

			this.$http.post("/api/shopPay/calculateDiscountAmount", {
				startTime: date_1,
				endTime: date_2,
				shopId: this.ruleForm.shopId,
			}).then(res => {
				console.log(res)
				if (res.data.code == 0) {
					this.ruleForm.diffDay = res.data.data.days
					this.ruleForm.rentConcessionMoney = res.data.data.amount
				} else {
					this.$message.error(res.data.data)
				}
			})

			// 计算两个日期之间的差值
			// let totalDays, diffDate
			// let myDate_1 = Date.parse(date_1)
			// let myDate_2 = Date.parse(date_2)
			// // 将两个日期都转换为毫秒格式，然后做差
			// diffDate = Math.abs(myDate_1 - myDate_2) // 取相差毫秒数的绝对值
			// totalDays = Math.floor(diffDate / (1000 * 3600 * 24)) // 向下取整
			// this.ruleForm.diffDay = totalDays + 1
			// return totalDays // 相差的天数
		},
		addUser() {
			this.userList.push({
				linkName: "",
				linkPhone: ""
			})
		},
		delUser() {
			this.userList.splice(this.userList.length - 1, 1);
		},
		addData2() {
			if (this.cardNum == "") {
				this.$message.error("请输入付款人账号")
				return
			}
			if (this.cardName == "") {
				this.$message.error("请输入付款人名称")
				return
			}

			this.$http.post("/api/bdShop/insertShopAccount", {
				accountId: this.cardNum,
				accountName: this.cardName,
				shopId: this.obj.id,
			}).then(res => {
				if (res.data.code == 0) {
					this.getAll3();
					this.innerVisible = false;
					this.$message.success("保存成功")
				} else {
					this.$message.error(res.data.data)
				}
			}).catch(err => {

			})
		},
		getAll3() {
			this.data2 = []
			this.$http.get("/api/bdShop/getShopAccount?shopId=" + this.obj.id).then(res => {
				if (res.data.code == 0) {
					this.data2 = res.data.data
				} else {
					this.$message.error(res.data.message)
				}
			}).catch(err => {

			})
		},

		addRow3() {
			this.cardNum = ""
			this.cardName = ""
			this.innerVisible = true;
		},
		setRow4(obj) {
			this.obj = JSON.parse(JSON.stringify(obj))
			this.ruleForm = JSON.parse(JSON.stringify(this.oldRuleForm))
			this.ruleForm.brandName = obj.brandName;
			this.ruleForm.shopId = obj.id;
			this.dateArr = [];
			this.changeDateArr();
			this.show4 = true;
		},
		handleClick4() {
			if (this.activeName4 == "second") {
				this.data4 = []
				this.$http.post("/api/shopPay/selectShopPayReadjust", {
					"shopId": this.ruleForm.shopId,
					"currentPage": 1,
					"pageSize": 100000
				}).then(res => {
					if (res.data.code == 0) {
						this.data4 = res.data.data.items

						// this.$message.success(res.data.message)
					} else {
						// this.$message.error(res.data.message)
					}
				})
			} else {
				this.ruleForm.brandName = this.obj.brandName;
				this.ruleForm.shopId = this.obj.id;
			}
		},
		submitForm(formName) {
			if (this.ruleForm.startTime == "" || this.ruleForm.endTime == "") {
				this.$message.error("请选择减租时间")
				return
			}
			this.$refs[formName].validate((valid) => {
				if (valid) {
					this.$http.post("/api/shopPay/insertShopPayReadjust", this.ruleForm).then(res => {
						if (res.data.code == 0) {
							this.$message.success(res.data.message)
							this.resetForm('ruleForm');
							this.ruleForm.brandName = this.obj.brandName;
							this.ruleForm.shopId = this.obj.id;
							// this.getAll3();
						} else {
							this.$message.error(res.data.message)
						}
					})
				} else {
					console.log('error submit!!');
					return false;
				}
			});
		},
		resetForm(formName) {
			this.activeName4 = "first"
			this.data4 = []
			this.dateArr = [];
			this.$refs[formName].resetFields();


		},
		setRow3(obj) {
			this.obj = obj;
			this.getAll3();
			this.show3 = true;
		},
		delRow(row) {
			this.$confirm('是否确定删除?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消'
			}).then(() => {
				this.$http.get("/api/bdShop/deleteShopAccount?id=" + row.id).then(res => {
					if (res.data.code == 0) {
						this.$message.success("删除成功")
						this.getAll3();
					} else {
						this.$message.error("删除失败")
					}
				})
			}).catch(() => {
				this.$message({
					message: '已取消删除'
				});
			});
		},
		tb() {
			this.$http.post("/api/shop/code/init", {}).then(res => {
				if (res.data.code == 0) {
					this.getAll()
					this.$message.success(res.data.message)
				} else {
					this.$message.error(res.data.message)
				}
			}).catch(err => {

			})
		},
		//下载营收模板
		revenueTemplate() {
			this.$http.post(`/api/safe/code/download`, {}, {
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json;charset=utf-8",
				},
				responseType: "blob"
			}).then(res => {
				const link = document.createElement("a");
				let blob = new Blob([res.data], {
					type: "application/vnd.ms-excel"
				});
				link.style.display = "none";
				link.href = URL.createObjectURL(blob);
				link.download = "营收导入模板.xls";
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			})
		},
		addTemplate() { //下载导入模板
			this.$http.post(`/api/shop/code/download`, {}, {
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json;charset=utf-8",
				},
				responseType: "blob"
			}).then(res => {
				const link = document.createElement("a");
				let blob = new Blob([res.data], {
					type: "application/vnd.ms-excel"
				});
				link.style.display = "none";
				link.href = URL.createObjectURL(blob);
				link.download = "水电仪表编码导入模板.xls";
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			})
		},
		success(res) {
			if (res.code == 0) {
				this.getAll()
				this.$message.success("导入成功")
			} else {
				this.$message.error(res.message)
				this.isFail = true
				this.czList = res.data
			}
		},

		setRow(obj, type) {
			if (type == 1) {
				this.title = "查看"
				if (obj.zsContractEntity) {
					this.$router.push({
						name: '商铺详情',
						params: {
							val: obj
						}
					})
				} else {
					this.$message("暂无内部合同，无法查看")
				}

			} else {
				this.userList = []
				this.title = "编辑"
				this.form = {
					...obj
				}
				let linkNameList = []
				let linkPhoneList = []
				if (this.form.linkName) {
					linkNameList = this.form.linkName.split(",");
					linkPhoneList = this.form.linkPhone.split(",");
					linkNameList.forEach((element, index) => {
						this.userList.push({
							linkName: element,
							linkPhone: linkPhoneList[index]
						})
					});
				} else {
					this.userList.push({
						linkName: "",
						linkPhone: ""
					})
				}


				this.show = true
			}

		},
		dc() {
			publicExport("/api/bdShop/exportShop", this.selectForm, "商铺信息")
		},
		ok() {
			if (this.form.storey == null || this.form.storey == '') {
				this.$message("所属楼层不能为空")
				return
			}
			let linkNameList = [];
			let linkPhoneList = [];
			this.userList.forEach(element => {
				linkNameList.push(element.linkName)
				linkPhoneList.push(element.linkPhone)
			});
			this.form.linkName = linkNameList.toString();
			this.form.linkPhone = linkPhoneList.toString();
			let url = "/api/bdShop/addShop"
			if (this.title == "编辑") {
				url = "/api/bdShop/updateShop"
			}

			this.$http.post(url, this.form).then(res => {
				if (res.data.code == 0) {
					this.getAll();
					this.show = false
					this.$message.success(`${this.title}成功`)
				} else {
					this.$message.error(res.data.message)
				}
			})
		},

		addRow() {
			this.form = JSON.parse(JSON.stringify(this.oldForm))
			this.title = "新增"
			this.show = true;
		},
		getAll() {
			this.$http.post("/api/bdShop/queryShop", this.selectForm).then(res => {
				this.data = res.data.data.items
				this.count = res.data.data.totalNum
			})
		},
		handleCreate() {
			this.title = "新增"
			this.show = true;
		},
		handleClick() {
			this.getAll()
		},
		handleCurrentChange(val) {
			this.selectForm.currentPage = val;
			this.getAll()
		},
		handleSizeChange(val) {
			this.selectForm.pageSize = val;
			this.getAll()
		},
		clearSearch() {
			this.$refs.myAutocomplete.handleFocus()
		},
		querySearchAsync(queryString, cb) {
			if (this.form.linkName == undefined) {
				this.form.linkName = ''
			}
			//?name=${this.form.linkName}
			this.$http.get(`/api/system/role/authUser/allocatedList`, {
				params: {
					roleId: 8
				}
			}).then(res => {
				res.data.rows.forEach(val => {
					// var a=val.checkInTime.split('T')[0]
					// var b=a.split('T')[0]
					val.opinion = val.userName + '-' + val.phonenumber + '-' + val.nickName
				})

				let result = res.data.rows;
				cb(result);
			})
		},
		handleSelect(item) {
			this.form.linkPhone = item.phonenumber
			this.form.linkCard = item.cardId
			this.form.userId = item.userId
			this.form.linkName = item.userName
			// this.formData.name=item.name
		},
	},
	created() {
		this.getShopList();
		this.oldForm = JSON.parse(JSON.stringify(this.form))
		this.oldRuleForm = JSON.parse(JSON.stringify(this.ruleForm))
		this.getAll();
	}
}
</script>

<style scoped="scoped"></style>
